import axios from "axios";

//TODO: Need to add annotation for this function once the API is ready

const optExpiredReqPinApi =
    "/participant-web-services/rest/partialauth/otpExpiredRequestPin/:optOut";

export const optOutWithExpiredOTPAndReqPin = async (isOptOutParams) => {
    try {
        const response = await axios.post(
            `${window.__baseApiUrl__}${optExpiredReqPinApi}`,
            { optOut: isOptOutParams },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.log("Errororr", error);
        return error;
    }
};
